<template>
  <div class="agreement-warning__form">
    <h3>Проект на витрине!</h3>
    <p>
      Скорректируйте карточку для витрины или снимите проект с публикации, а
      затем завершите проект.
    </p>

    <div class="agreement-warning__form-buttons">
      <c-button-secondary @click="handleOnContinue">
        Продолжить
      </c-button-secondary>
      <c-button-primary @click="handleOnEdit">
        Редактировать карточку
      </c-button-primary>
    </div>
  </div>
</template>

<script setup>
  import CButtonPrimary from '@/components/UI/CButtonPrimary.vue';
  import CButtonSecondary from '@/components/UI/CButtonSecondary.vue';

  const emit = defineEmits(['close', 'continue', 'edit']);

  const handleOnContinue = async () => {
    emit('continue');
    emit('close');
  };

  const handleOnEdit = async () => {
    emit('edit');
    emit('close');
  };
</script>

<style lang="scss" scoped>
  @use "@/assets/styles/_colors.scss" as *;
  * {
    margin: 0;
  }

  .agreement-warning__form {
    padding: 112px 17px 0 17px;

    h2 {
      font: 700 16px/22px 'Nunito Sans';
    }

    p {
      margin-top: 21px;
    }

    .form__task-info {
      background: $color-bg-secondary-grey;
      flex-direction: column;
      height: 161px;
      margin-top: 40px;
      padding: 20px;

      .form__task-group {
        color: $color-bg-status-new;
        font: 700 14px/20px 'Nunito Sans';
        margin-top: 18px;

        .counter {
          font-weight: 400;
          margin-left: 10px;
        }
      }
    }

    &-buttons {
      width: 100%;
      display: flex;
      flex-direction: row;
      justify-content: flex-end;
      margin-top: 50px;

      & > button {
        margin-left: 10px;

        &:first-child {
          margin-left: 0;
        }
      }
    }
  }
</style>
